module.exports = __webpack_public_path__ + "static/media/gtm5.1daab1af.png";